import { CIcon } from '~/icons/types'

export const ciPlay: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M18.232 10.317 7.081 3.147A2 2 0 0 0 4 4.831v14.336a2 2 0 0 0 3.082 1.683l11.15-7.169a2 2 0 0 0 0-3.364Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'play',
  type: 'solid'
}
